
import Vue from 'vue'

export default Vue.extend({
  name: 'ArrowsSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
